import React from 'react';
import styled from 'styled-components';
import { Grid, Card } from '@material-ui/core';
import { ShortBody } from 'components/Typography';

export const StyledCard = styled(
  ({ paddingRight, paddingLeft, ...otherProps }) => <Card {...otherProps} />,
)`
  && {
    padding: 16px 24px;
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right bottom 55%;
    box-shadow: none;
    border-radius: 8px;
    padding-right: ${(props) => props.paddingRight};
    padding-left: ${(props) => props.paddingLeft};
  }
`;
export const StyledShortBody = styled(({ matches, lineHeight, ...props }) => (
  <ShortBody {...props} />
))`
  &&& {
    size: 16px !important;
    margin-bottom: 0px;
    line-height: ${({ lineHeight }) => lineHeight};
    font-size: 10px !important;
  }
`;
export const StyledGridLeft = styled(Grid)`
  margin-left: 2px !important;
`;
